import {RouteLocationNormalized, RouterView} from "vue-router";
import {IBreadcrumbMeta} from "cdp-fe-commons-layout";

const Istanze = () => import('@/views/istanze/Istanze.vue')
const OnlineRequestForm = () => import('@/views/istanze/OnlineRequestForm.vue')
const ArchivioIstanze = () => import('@/views/istanze/ArchivioIstanze.vue')
const Lavagna = () => import('@/views/istanze/Lavagna.vue')

const istanzeRoutes = [
    {
        path: 'istanza',
        name: 'Le tue Istanze',
        component: RouterView,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'ListaMiaIstanza',
                component: Istanze,
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                },
            },
            {
                path: 'richiestaonline/:codiceIstanza',
                name: "Compila richiesta da istanza",
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        customName: "Compila Online"
                    } as IBreadcrumbMeta
                },
                component: OnlineRequestForm,
            },
            {
                path: 'lavagna/:codiceIstanza',
                name: "Lavagna Richiesta",
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        customName: "Lavagna"
                    } as IBreadcrumbMeta
                },
                component: Lavagna,
            }
        ]
    },
    {
        path: 'archivio',
        name: 'Archivio Istanze',
        component: RouterView,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'ArchivioDelleIstanze',
                component: ArchivioIstanze,
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                },
            },
            {
                path: ':codiceIstanza',
                name: "Istanza Archiviata",
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        customNameBeforeResolve: (to: RouteLocationNormalized) => {
                            return Promise.resolve(to.params.codiceIstanza as string ?? 'Istanza');
                        },
                    } as IBreadcrumbMeta,
                },
                component: Lavagna,
            }
        ]
    },
    {
        path: 'istanza-collaborazione',
        name: 'Le tue istanze in collaborazione',
        component: RouterView,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '',
                name: 'ListaIstanzaCollaborazione',
                component: Istanze,
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        exclude: true
                    } as IBreadcrumbMeta,
                },
            },
            {
                path: 'richiestaonline/:codiceIstanza',
                name: "Compila richiesta da istanza in collaborazione",
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        customName: "Compila Online"
                    } as IBreadcrumbMeta
                },
                component: OnlineRequestForm,
            },
            {
                path: 'lavagna/:codiceIstanza',
                name: "Lavagna Richiesta in Collaborazione",
                meta: {
                    requiresAuth: true,
                    breadcrumb: {
                        customName: "Lavagna"
                    } as IBreadcrumbMeta
                },
                component: Lavagna,
            }
        ]
    },
];

export default istanzeRoutes;